package com.shadowings.gero.data.lessons.chapter3
import com.shadowings.gero.data.lessons.inlineMeaning
import com.shadowings.gero.data.lessons.DistractorPool
import com.shadowings.gero.data.lessons.calculateDirectGenitivePhrases
import com.shadowings.gero.data.lessons.tokenizePhrase


import androidx.compose.foundation.layout.Row
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.WordSelectionContent
import com.shadowings.gero.presentation.component.MdCWord
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_accostiamo_la_parola_per_mucca_iht_a_quella_p
import gero.composeapp.generated.resources.exp_content_accostiamo_semplicemente_la_parola_per_vino_i
import gero.composeapp.generated.resources.exp_content_come_vedi_il_genitivo_diretto_facilissimo_da_
import gero.composeapp.generated.resources.exp_content_fai_attenzione_anche_all_ordine_di_lettura
import gero.composeapp.generated.resources.exp_content_il_genitivo_diretto_si_forma_semplicemente_ac
import gero.composeapp.generated.resources.exp_content_in_italiano_usiamo_preposizioni_articolate_co
import gero.composeapp.generated.resources.exp_content_la_struttura_semplicissima_n_n_nome_posseduto
import gero.composeapp.generated.resources.exp_content_oggi_impariamo_come_esprimere_il_possesso_in_
import gero.composeapp.generated.resources.exp_content_ora_siamo_pronti_per_fare_pratica_con_i_pross
import gero.composeapp.generated.resources.exp_content_prendiamo_ad_esempio_la_frase_n_il_vino_del_p
import gero.composeapp.generated.resources.exp_content_vediamo_un_altro_esempio_n_la_mucca_del_pasto
import gero.composeapp.generated.resources.exp_title_esempio_1
import gero.composeapp.generated.resources.exp_title_esempio_2
import gero.composeapp.generated.resources.exp_title_genitivo_diretto
import gero.composeapp.generated.resources.exp_title_introduzione
import gero.composeapp.generated.resources.exp_title_lezione_completata

fun getGenitivoDirettoContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_introduzione,
            content = Res.string.exp_content_oggi_impariamo_come_esprimere_il_possesso_in_,
            face = Faces.Happy
        ),
        ExplanationContent(
            title = Res.string.exp_title_introduzione,
            content = Res.string.exp_content_in_italiano_usiamo_preposizioni_articolate_co,
            face = Faces.Idle
        ),
        ExplanationContent(
            title = Res.string.exp_title_genitivo_diretto,
            content = Res.string.exp_content_il_genitivo_diretto_si_forma_semplicemente_ac,
            face = Faces.Idle
        ),
        ExplanationContent(
            title = Res.string.exp_title_genitivo_diretto,
            content = Res.string.exp_content_la_struttura_semplicissima_n_n_nome_posseduto,
            face = Faces.Serious
        ),
        ExplanationContent(
            title = Res.string.exp_title_esempio_1,
            content = Res.string.exp_content_prendiamo_ad_esempio_la_frase_n_il_vino_del_p,
            face = Faces.Happy
        ),
        ExplanationContent(
            title = Res.string.exp_title_esempio_1,
            content = Res.string.exp_content_accostiamo_semplicemente_la_parola_per_vino_i,
            face = Faces.Surprised,
            composable = {
                Row {
                    MdCWord(
                        word = "M17-D21:Q3-W22:Z2-M17-X1:I9-A1",
                        rtl = false,
                        cart = false
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_esempio_2,
            content = Res.string.exp_content_vediamo_un_altro_esempio_n_la_mucca_del_pasto,
            face = Faces.Happy
        ),
        ExplanationContent(
            title = Res.string.exp_title_esempio_2,
            content = Res.string.exp_content_accostiamo_la_parola_per_mucca_iht_a_quella_p,
            face = Faces.Surprised,
            composable = {
                Row {
                    MdCWord(
                        word = "M17-V28-X1:F1A-A47-G43-A1",
                        rtl = false,
                        cart = false
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_esempio_2,
            content = Res.string.exp_content_fai_attenzione_anche_all_ordine_di_lettura,
            face = Faces.Surprised,
            composable = {
                Row {
                    MdCWord(
                        word = "M17-V28-X1:F1A-A47-G43-A1",
                        rtl = true,
                        cart = false
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_lezione_completata,
            content = Res.string.exp_content_come_vedi_il_genitivo_diretto_facilissimo_da_,
            face = Faces.Perfect
        ),
        ExplanationContent(
            title = Res.string.exp_title_lezione_completata,
            content = Res.string.exp_content_ora_siamo_pronti_per_fare_pratica_con_i_pross,
            face = Faces.Happy
        )
    )
}

fun getGenitivoDirettoQuizContent(words: List<Word>, languageCode: String): List<IQuizContent> {
    val validPairs = listOf(
        Pair("PESCE", "GATTO"),
        Pair("MUCCHE", "PASTORE"),
        Pair("MUCCA", "PADRE"),
        Pair("PANE", "PASTORE"),
        Pair("ACQUA", "GATTO"),
        Pair("VINO", "PASTORE"),
        Pair("FALCO", "PADRE"),
        Pair("BIRRA", "SACERDOTE"),
        Pair("PANE", "SCRIBA"),
        Pair("ACQUA", "TORO"),
        Pair("VINO", "UOMO"),
        Pair("GRANO", "MUCCA"),
        Pair("GATTO", "DONNA"),
        Pair("ALBERO", "PASTORE"),
        Pair("FALCHI", "SCRIBA"),
        Pair("PANE", "PADRE"),
        Pair("UCCELLO", "GATTO"),
        Pair("BIRRA", "DONNA"),
        Pair("PANE", "MADRE"),
        Pair("VINO", "SACERDOTE"),
        Pair("INCENSO", "INEPU")
    )

    val phrases = calculateDirectGenitivePhrases(words, validPairs, 15, languageCode)
    val quizList = mutableListOf<IQuizContent>()

    phrases.forEach { phrase ->
        val word1 = phrase.word1
        val word2 = phrase.word2
        val correctTokens = phrase.correctTokens

        val otherWords = DistractorPool.words(words).filter {
            val hasArticolo =
                !it.getArticolo(languageCode).isNullOrBlank() && it.getArticolo(languageCode) != "-"
            val hasGenitivo =
                !it.getGenitivo(languageCode).isNullOrBlank() && it.getGenitivo(languageCode) != "-"
            it.id != word1.id && it.id != word2.id && hasArticolo && hasGenitivo
        }
        val wrongWords = otherWords.shuffled().take(3)

        // tokenizePhrase splits any multi-word field (a compound vocabulary meaning like
        // "König von Oberägypten", or a multi-word Spanish genitive like "de la") into
        // separate one-word tiles instead of one glued distractor tile.
        val wrongTokens = mutableListOf<String>()
        wrongWords.forEach { ww ->
            ww.getArticolo(languageCode)?.let { if (it != "-") wrongTokens.addAll(tokenizePhrase(it)) }
            val meaning = ww.inlineMeaning(languageCode, ww.getMeaning(languageCode).split(",")[0].trim())
            wrongTokens.addAll(tokenizePhrase(meaning))
            ww.getGenitivo(languageCode)?.let { if (it != "-") wrongTokens.addAll(tokenizePhrase(it)) }
        }

        // Never let a distractor collide (case-insensitively) with a token the correct answer
        // actually needs — otherwise a duplicate tile would silently swallow the real one.
        // distinct() only applies to the distractor pool: correctTokens can legitimately repeat a
        // word (e.g. "the wine of the priest" needs "the" twice), and deduping the combined list
        // would collapse that into a single tile, making the phrase unanswerable.
        val allWordsList = (correctTokens + wrongTokens.filter { wt ->
            correctTokens.none { it.trim().lowercase() == wt.trim().lowercase() }
        }.distinct())
            .filter { it.isNotBlank() }
            .shuffled()

        quizList.add(
            WordSelectionContent(
                hieroglyphs = phrase.hieroglyphs,
                correctPhrase = phrase.correctPhrase,
                words = allWordsList,
                transliteration = "${phrase.word1.reading} ${phrase.word2.reading}"
            )
        )
    }

    return quizList
}